module.exports = __webpack_public_path__ + "img/18.cc8a3c65.png";